import { fetchData } from '../../../global/utils/fetch'
import { ITechnicianMessage } from '../../../../../app/entities/TechnicianMessage'

const API_BASE = `${process.env.REACT_APP_ORIGIN}/technician-messages`

/**
 * Get all technician messages
 */
export const getAllMessages = async (): Promise<ITechnicianMessage[]> => {
  const messages = await fetchData<ITechnicianMessage[]>({
    url: API_BASE,
    method: 'GET',
  })
  return messages
}

/**
 * Create a new technician message
 */
export const createMessage = async (
  message: Omit<
    ITechnicianMessage,
    | 'objectId'
    | 'createdAt'
    | 'created'
    | 'updated'
    | 'status'
    | 'acknowledgedBy'
  >,
): Promise<ITechnicianMessage> => {
  const createdMessage = await fetchData<ITechnicianMessage>({
    url: API_BASE,
    method: 'POST',
    body: message,
  })
  return createdMessage
}

/**
 * Delete a technician message
 */
export const deleteMessage = async (objectId: string): Promise<boolean> => {
  await fetchData({
    url: `${API_BASE}/${objectId}`,
    method: 'DELETE',
  })
  return true
}

/**
 * Acknowledge a technician message
 */
export const acknowledgeMessage = async (
  messageId: string,
  userId: string,
  clickedLinks?: string[],
): Promise<boolean> => {
  await fetchData({
    url: `${API_BASE}/acknowledge`,
    method: 'POST',
    body: {
      messageId,
      userId,
      acknowledgedAt: new Date().toISOString(),
      clickedLinks,
    },
  })
  return true
}
